import React, {useContext, useEffect} from 'react';
import style from './style';
import i18next from "i18next";
import {Context} from "../../../../../../states/Store";
import Attribute from "../../../../AddContext/steps/ContextAttributes/Attribute";
import EAButton from "../../../../../../components/common/EAButton";
import Header from "../Header";

const TpAttributes = ({tiersAttributes, tpToAdd, onEditAttribute, onCancel, onValidate}) => {
    const {classes} = style();
    const [, dispatch] = useContext(Context);

    useEffect(() => {
        dispatch({type: "IS_ASSOCIATING_CONTEXT_THIRDPARTY", isAssociatingContextThirdParty: true});
    }, [dispatch]);

    useEffect(() => {
        return () => {
            dispatch({type: "IS_ASSOCIATING_CONTEXT_THIRDPARTY", isAssociatingContextThirdParty: false});
        }
    }, [dispatch]);

    return <div className={classes.root}>
        <Header tp={tpToAdd}/>
        <div className={classes.attributes}>
            {tiersAttributes.map((tiersAttribute) => (
                <div key={tiersAttribute.attributeId}>
                    <Attribute
                        contexteAttribute={tiersAttribute}
                        onValidateSuccess={onEditAttribute}
                        currentValue={tiersAttributes.find(
                            (c) => c.label === tiersAttribute.label
                        )}
                    />
                </div>
            ))}
        </div>
        <div className={classes.buttons}>
            <EAButton
                onClick={onCancel}
                content={i18next.t('cancel')}
                colorVariant={'secondary'}
            />
            <EAButton
                onClick={onValidate}
                content={i18next.t('validate')}
                colorVariant={'primary'}
                customStyle={{
                    marginLeft: '14px'
                }}
            />
        </div>
    </div>
}

export default TpAttributes;